import { Routes } from '@angular/router';

export const formsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/forms/forms.component').then(c => c.FormsComponent),
    data: { pageTitle: 'PAGES.FORMS.TITLE', pageType: 'list', isAnonymous: true }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-form/add-edit-form.component').then(c => c.AddEditFormComponent),
    data: { pageTitle: 'PAGES.FORMS.ADD', pageType: 'add', isAnonymous: true }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-form/add-edit-form.component').then(c => c.AddEditFormComponent),
    data: { pageTitle: 'PAGES.FORMS.EDIT', pageType: 'edit', isAnonymous: true }
  },
  {
    path: ':id',
    loadComponent: () => import('./pages/form-questions/form-questions.component').then(c => c.FormQuestionsComponent),
    data: { pageTitle: 'PAGES.FORMS.QUESTIONS', pageType: 'list', isAnonymous: true }
  },
  {
    path: ':formId/answers/:submitId',
    loadComponent: () => import('./pages/single-form-answer/single-form-answer.component').then(c => c.SingleFormAnswerComponent),
    data: { pageTitle: 'PAGES.FORM_ANSWERS.SINGLE_ANSWER', pageType: 'view', isAnonymous: true }
  },
  {
    path: ':formId/answers',
    loadComponent: () => import('./pages/form-answers/form-answers.component').then(c => c.FormAnswersComponent),
    data: { pageTitle: 'PAGES.FORM_ANSWERS.TITLE', pageType: 'list', isAnonymous: true }
  }
];

